import React, { useState } from 'react';
import { Link } from 'gatsby';
import { useIntl } from 'gatsby-plugin-intl';
import { useScrollPosition } from '@n8tb1t/use-scroll-position';

import Logo from '../../svgs/Logo';
import { Cart } from '../Cart';
import { LanguageSwitcher } from './LanguageSwitcher';
import { MenuLink } from './styles';
import { MobileMenu } from './MobileMenu';

const Navigation = ({ isHomepage = false }) => {
  const { formatMessage, locale } = useIntl();
  const [currentPosition, setCurrentPosition] = useState(0);

  useScrollPosition(({ currPos }) => {
    setCurrentPosition(currPos.y);
  });

  const fixedStyles = `w-full fixed top-0 left-0 py-4 bg-white ${
    currentPosition < 0 ? 'border-b' : ''
  } z-50 border-gray-200 z-50`;
  const absoluteStyles = `w-full absolute top-0 left-0 py-4 ${isHomepage ? 'lg:py-8 lg:py-16' : ''} bg-white z-50`;

  return (
    <nav className={currentPosition < -200 || !isHomepage ? fixedStyles : absoluteStyles}>
      <div className="xl:container mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between">
        <div className="flex-1">
          <Link to={`/${locale}/`}>
            <Logo
              width={currentPosition < -200 || !isHomepage ? 48 : 64}
              height={currentPosition < -200 || !isHomepage ? 48 : 64}
            />
          </Link>
        </div>

        <div className="hidden lg:block">
          <MenuLink to={`/${locale}/`} className="p-5">
            {formatMessage({ id: 'menu.home' })}
          </MenuLink>
          <MenuLink to={`/${locale}/screens`} className="p-5">
            {formatMessage({ id: 'menu.screens' })}
          </MenuLink>
        </div>

        <div className="flex-1 flex items-center justify-end">
          <LanguageSwitcher />
          {/* <Search className="hidden lg:block" /> */}
          <MobileMenu />
          <Cart />
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
